import React from 'react';
import { Redirect } from 'react-router-dom';
import { getToken } from 'contexts/AuthContext';

function AppGuard(props: any) {
  const { children } = props;
  const token = getToken();
  if (!token) return <Redirect to="/connexion" />;

  return children;
}

export default AppGuard;
